export { default as Tag } from './Tag';
export type { TagProps } from './Tag';
